import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['type', 'unit', 'hint']
  static values = { units: Object }

  connect () {
    this.update()
  }

  update () {
    const entry = this.unitsValue[this.typeTarget.value] || {}
    if (this.hasUnitTarget) this.unitTarget.textContent = entry.unit ? `(${entry.unit})` : ''
    if (this.hasHintTarget) this.hintTarget.textContent = entry.hint || ''
  }
}
